import React from "react";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import DataGrid from '@dataGrid';
import GridConfig from "./GridConfig";
import styles from "./../styles";
import { csvFormulaInjectionSanitizer } from "../../../../../../utilities/csvUtils";
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from "../GridHeader";
import Events from "../../../../../../utilities/EventEmitter";
import { getUniqueKeyForStripPriorityRowData } from "../../utils";
import { PrintReport } from "../../../../../common";
import { getDisplayedRowData } from "../../../../../common/PrintReport/utils/reportDataFormatter";

class Trailers extends React.Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.state = {
      quickFilterText: "",
      showMergeCustomerAlert: false,
    };
    this.selectedTrailers = [];
    this.printRef = React.createRef(null);
    this.beforePrintFn = null;
    this.gridConfig = new GridConfig({
      terminal: this.props.userData.userProfile.terminal.code,
      userConfig: this.props.userData.userProfile?.columnPref
    });
    this.headerId="StripPriority"
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
    if (this.props.trailersData?.length) {
      this.updateTrailersForShipments();
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.trailersData !== prevProps.trailersData &&
      this.props.trailersData?.length
    ) {
      this.setSelectTrailers();
    }
  }

  setSelectTrailers = () => {
    if (!this.gridApi?.forEachNode) {
      return;
    }
    this.gridApi.forEachNode((node) => {
      const trailerUniqueCode = getUniqueKeyForStripPriorityRowData(node.data.trailerNumber, node.data.trailerScac);
      if (this.selectedTrailers.includes(trailerUniqueCode)) {
        node.setSelected(true); // props are isSelected, clearOtherSelection, suppressFinishActions
        if (this.gridApi.ensureIndexVisible) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
        }
      }
    });
    this.updateTrailersForShipments();
  };

  updateQuickFilterText = (searchText) => {
    this.setState({
      quickFilterText: searchText,
    });
  };

  exportCSV = () => {
    if (!this.props.trailersData?.length || !this.gridApi) {
      return;
    }
    const columns = this.gridApi.getColumns();
    const columnKeys = columns
      .filter(column => !column.colDef.hide)
      .map(column => column.getColId());

    const params = {
      fileName: "Strip_Priority_Trailers_Report",
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value),
    };
    this.gridApi.exportDataAsCsv(params);
  };

  constructStatusBar = (filteredData) => {
    return [
      {
        label: `${filteredData.length || 0} Total Trailers`,
        filterCondition: "",
      },
    ];
  };

  // Walk displayed nodes (not getSelectedRows()) so order matches sorted Trailers grid display.
  // trailerDisplayOrder drives print section order when nothing is selected; selectedTrailers when some are.
  updateTrailersForShipments = () => {
    if (!this.gridApi?.forEachNodeAfterFilterAndSort) {
      return;
    }
    const selectedTrailers = [];
    const trailerDisplayOrder = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      const trailerKey = getUniqueKeyForStripPriorityRowData(
        node.data.trailerNumber,
        node.data.trailerScac
      );
      trailerDisplayOrder.push(trailerKey);
      if (node.isSelected()) {
        selectedTrailers.push(trailerKey);
      }
    });
    this.selectedTrailers = selectedTrailers;
    Events.emit("UpdateSelectedTrailersShipments", {
      selectedTrailers,
      trailerDisplayOrder,
    });
  };

  handleRefreshClick = () => {
    this.props.onRefreshStripPriority();
  };

  setPrintRef = (compRef, beforePrintFn) => {
    this.printRef = compRef;
    this.beforePrintFn = beforePrintFn;
  }

  getPrintDataFn = () => {
    const rowData = [];
    this.gridApi.forEachNodeAfterFilterAndSort((node) => {
      rowData.push(node.data);
    })
    return getDisplayedRowData({
      headerProps: {
        title: "IB Trailer Strip Priority",
        headerDetails: [
          {
            label: rowData?.length || 0,
            value: "Total Trailers",
          },
        ],
      },
    });
  }
 
  render() {
    const { classes, toggleMaximize, isMaximized } = this.props;
    const { config } = this.gridConfig;
    return (
      <>
        <div className={classes.trailerContainer}>
          <GridHeader
            exportCSV={this.exportCSV}
            title="IB Trailer Strip Priority"
            updateQuickFilterText={this.updateQuickFilterText}
            showPrint
            gridApi={this.gridApi}
            handleRefreshClick={this.handleRefreshClick}
            onBeforeGetContent={this.beforePrintFn}
            printRef={this.printRef}
            toggleMaximize={toggleMaximize}
            isMaximized={isMaximized}
            headerId={this.headerId}
            userProfile={this.props.userData.userProfile}
          />
          <div>
            <div className={`${classes.dataGrid} ${isMaximized ? '' : classes.trailerGridHeight}`}>
              <DataGrid
                columnDefs={config.columns}
                config={config}
                rowData={this.props.trailersData}
                enableSorting={config.enableSorting}
                onGridReady={this.onGridReady}
                quickFilterText={this.state.quickFilterText}
                rowSelection={this.gridConfig.config.rowSelection}
                rowDeselection={this.gridConfig.config.rowDeselection}
                onSelectionChanged={this.updateTrailersForShipments}
                onSortChanged={this.updateTrailersForShipments}
                onCellMouseDown={this.onCellFocused}
                onRowClicked={this.onRowClicked}
                showErrorMessage={this.props.stripPriorityGridStatus}
                panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
              />
            </div>
          </div>
        </div>
        <PrintReport
          gridApi={this.gridApi}
          setPrintRef={this.setPrintRef}
          getPrintDataFn={this.getPrintDataFn}
        />
      </>
    );
  }
}
export default compose(withStyles(styles), withUserProfile)(Trailers);
